export {
  default as volleyball,
  ReactComponent as Volleyball,
} from '@assets/icons/features-and-amenities/volleyball.svg'    
